import { useEffect } from 'react';
import { Coins } from 'lucide-react';
import { usePointStore } from '@/store/pointStore';

const TOAST_DURATION_MS = 3000;

/**
 * 전역 포인트 토스트 렌더러
 * - usePointStore.toastQueue 를 구독해서 오른쪽 하단에 플로팅 카드로 표시
 * - 각 토스트는 3초 후 자동 제거
 * - 출석/글쓰기/댓글/Socket 'point:earned' 이벤트 등에서 addToQueue 로 사용
 */
export function PointToaster() {
  const toasts = usePointStore((s) => s.toastQueue);
  const remove = usePointStore((s) => s.removeFromQueue);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      setTimeout(() => remove(t.id), TOAST_DURATION_MS),
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, remove]);

  if (toasts.length === 0) return null;

  // 모바일: 중앙 하단 텍스트 토스트(toastStore, bottom-20)와 겹치지 않도록 위로 띄움(bottom-36).
  // PC: 기존 우측 하단 유지.
  return (
    <div className="pointer-events-none fixed bottom-36 right-4 z-[100] flex flex-col gap-2 md:bottom-6 md:right-6">
      {toasts.map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto flex items-center gap-3 rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-3 animate-in fade-in slide-in-from-right-4"
          role="status"
        >
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--color-primary)]/10">
            <Coins className="h-5 w-5 text-[var(--color-primary)]" />
          </div>
          <div className="min-w-[140px]">
            {t.amount > 0 ? (
              <div className="text-base font-extrabold text-[var(--color-primary)]">
                +{t.amount.toLocaleString('ko-KR')}P
              </div>
            ) : (
              <div className="text-sm font-semibold text-[var(--color-text-sub)]">
                알림
              </div>
            )}
            <div className="text-xs text-[var(--color-text-sub)]">{t.action}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
